import { IContact, ICurrentUser, INotification } from '@/types';
import { request } from '@/utils';

export async function fetchContacts({
  page,
  size
}: {
  page: number;
  size: number;
}): Promise<{ rows: IContact[]; total: number }> {
  return request({
    url: '/my/contacts',
    params: {
      page,
      size
    }
  });
}

// GET /my/contacts/search?keyword=Stone
export async function searchContacts(keyword?: string): Promise<{ rows: IContact[]; total: number }> {
  return request({
    url: '/my/contacts/search',
    params: {
      keyword
    }
  });
}

export const deleteContactById = async (id: string): Promise<unknown> => {
  return request({
    url: `/my/contacts/${id}`,
    method: 'DELETE'
  });
};

export const updateContactById = async (id: string, data: Partial<IContact>): Promise<unknown> => {
  return request({
    url: `/my/contacts/${id}`,
    method: 'PUT',
    data
  });
};

export const createContact = async (data: Partial<IContact>): Promise<unknown> => {
  return request({
    url: `/my/contacts`,
    method: 'POST',
    data
  });
};

export async function getUserInfo(): Promise<ICurrentUser> {
  return await request({
    url: '/my/info',
    errorHandler: (e) => {
      console.log(e);
    }
  });
}

export async function sendEmail(data: { email: string }): Promise<any> {
  return request({
    url: '/my/bind-email/send',
    method: 'POST',
    data
  });
}

export async function bindEmail(data: { code: string }): Promise<any> {
  return request({
    url: '/my/bind-email',
    method: 'POST',
    data
  });
}

export async function bindTelegram(data: {
  callbackData: {
    auth_date: number;
    first_name: string;
    hash: string;
    id: number;
    photo_url: string;
    username: string;
  };
}): Promise<any> {
  return request({
    url: 'my/bind-telegram',
    method: 'POST',
    data
  });
}

export async function configNotification(data: INotification): Promise<any> {
  return request({
    url: '/my/notification',
    method: 'POST',
    data
  });
}

export async function fetchSignatureStyles(): Promise<any> {
  return request({
    url: '/my/signature-styles',
    method: 'GET'
  });
}

// POST /my/signature-styles
export async function createSignatureStyle(data: { image: string }): Promise<any> {
  return request({
    url: '/my/signature-styles',
    method: 'POST',
    data
  });
}

// DELETE /my/signature-styles/1
export async function deleteSignatureStyle(id: string): Promise<any> {
  return request({
    url: `/my/signature-styles/${id}`,
    method: 'DELETE'
  });
}

// POST /my/info
export async function updateUserInfo(data: { nickName: string }): Promise<any> {
  return request({
    url: '/my/info',
    method: 'POST',
    data
  });
}

// GET /my/statistics
export async function fetchStatistics(): Promise<any> {
  return request({
    url: '/my/statistics',
    method: 'GET'
  });
}

// GET /my/prepare-password-manager
export async function preparePasswordManager(): Promise<{
  identitySignMessageTemplate: string;
  identityVerifyMessageTemplate: string;
}> {
  return request({
    url: '/my/prepare-password-manager',
    method: 'GET'
  });
}

// POST /my/init-user-identity
export async function initUserIdentity(data: {
  signature: string;
  message: string;
  publicKey: string;
  randomSeed: string;
  randomSeedValue: string;
  encryptedPK: string;
  identityType: 'wallet' | 'password';
  tag?: string;
}): Promise<any> {
  return request({
    url: '/my/init-user-identity',
    method: 'POST',
    data
  });
}
// POST /my/prepare-singpass
export async function prepareSingpass(): Promise<any> {
  return request({
    url: '/my/prepare-singpass',
    method: 'POST'
  });
}

// POST my/bind-singpass

export async function connectSingpass(data: { code: string }): Promise<any> {
  return request({
    url: '/my/connect-singpass',
    method: 'POST',
    data
  });
}

// POST /my/switch-password-manager
export async function switchPasswordManager(data: { enable: boolean }): Promise<any> {
  return request({
    url: '/my/switch-password-manager',
    method: 'POST',
    data
  });
}

// POST /my/batch-public-keys
export async function getBatchPublicKeys(data: { addresses: string[] }): Promise<any> {
  return request({
    url: '/my/batch-public-keys',
    method: 'POST',
    data
  });
}
// POST /my/disconnect-singpass
export async function disconnectSingpass(): Promise<any> {
  return request({
    url: '/my/disconnect-singpass',
    method: 'POST'
  });
}

export const connectHubspot = async (data: { code: string; redirectUri: string }): Promise<any> => {
  return request({
    url: '/my/connect-hubspot',
    method: 'POST',
    data
  });
};

///my/prepare-uaepass
export async function prepareUaePass(): Promise<any> {
  return request({
    url: '/my/prepare-uaepass',
    method: 'POST'
  });
}
// POST /my/connect-uaepass
export async function connectUaePass(data: { code: string }): Promise<any> {
  return request({
    url: '/my/connect-uaepass',
    method: 'POST',
    data
  });
}
// POST /my/disconnect-uaepass
export async function disconnectUaePass(): Promise<any> {
  return request({
    url: '/my/disconnect-uaepass',
    method: 'POST'
  });
}
///my/set-primary-ekyc
export async function setPrimaryEkyc(data: 'uaepass' | 'singpass'): Promise<any> {
  return request({
    url: '/my/set-primary-ekyc',
    method: 'POST',
    data: {
      primaryEKyc: data
    }
  });
}
